import { ReactCodeLifecycleState, ReactCodeStatusModel } from '../../../api/api';

/** Each request waits on the server; continuation always targets the original immutable build. */
export async function buildAndPublishReactCode(
	request: (buildId: string | undefined) => Promise<ReactCodeStatusModel>,
	onStatus: (status: ReactCodeStatusModel) => void,
	signal: AbortSignal,
): Promise<ReactCodeStatusModel> {
	let buildId: string | undefined;
	while (true) {
		if (signal.aborted) throw new Error('Build and publish cancelled');
		const status = await request(buildId);
		if (!status.buildId || (buildId && status.buildId !== buildId)) {
			throw new Error('Build and publish returned a different or missing BuildId');
		}
		buildId = status.buildId;
		onStatus(status);
		if (status.state === ReactCodeLifecycleState.Published || status.state === ReactCodeLifecycleState.Failed) return status;
		if (status.state !== ReactCodeLifecycleState.Compiling) throw new Error('Build finished without a confirmed publication');
	}
}
